<template>
  <va-edit-layout>
    <foundations-form :id="id" :title="title" :item="item"></foundations-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
